import React, { Component } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { Redirect } from 'react-router-dom';

import { LogoHeader } from '../../../containers/Components/index'

class About extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: false,
      signup: false,
      warning: "",
      showVerify: false,
      html_btn_status: 0,
    };
    this.user_name = "";
    this.pwd = "";
  }

  renderRedirect = () => {
    if (this.state.login) {
      return <Redirect to= { '/login/'} />
    }
    if (this.state.signup) {
      return <Redirect to= { '/register/'} />
    }
  }
  render() {

    // let slider_count = 4;
    // if (window.innerWidth < 520) {
    //   slider_count = 4;
    // }

    return (
      <div className="app flex-row font-Poppins">
      {this.renderRedirect()}
        <React.Fragment>
        <LogoHeader />
        
        <div className="app-body p-0 m-0 width-100vw mt-5 ">
            <Container className = "background-white" fluid>
               <Row className = "about_page_gradient mt-3 ">
                 <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                 </Col>
                 <Col xs="6" sm="6" lg="2">
                  <h5 className = "m-3 text-white"> About Us </h5>
                 </Col>
                </Row>
                <Row>
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                  <Col xs="12" sm="12" lg="8">
                    <h6 className = "mt-5 pt-2 line-height-h">
                    <b>"We got promises to keep, and miles to go before we sleep!"</b>                     
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                    <b>We had a bright idea.</b>
                    <br></br>
                    AbilitàXR was created by guys who believe that XR (AR/VR/MR) is the 
                    next generation computing platform. We believe that eventually 3D digital objects will replace all the 
                    current 2D  digital artifacts. People will interact with computers just like they interact with 
                    physical objects. We want to help reach that ambitious goal. It is really the third generation 
                    computing revolution after mobile and cloud paradigm shift.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                    <b>So what is AbilitàXR?</b> 
                    <br></br>
                    ‘Abilità’ is Italian for ability or capability. AbilitàXR is a cloud platform 
                    that gives any person the capability to make remarkable experiences in AR/VR/MR. Using this 
                    platform, users can create, share and explore the new 3D reality without writing any code. 
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                    <b>But why AbilitàXR?</b>
                    <br></br>
                     AbilitàXR is our way of changing the way people create and experience XR. 
                    Our platform is built using the trusted Unity engine. It's a cloud platform, so you don't 
                    loose anything. Further, you deploy your expereience to native application with just a click of mouse.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                    <b>How does AbilitàXR work?</b>
                    <br></br>
                    If you are excited about XR and want to use it for your business, get onboard for free. With our 
                    ready-to-use templates for various business verticals, you can get started in no time. Should you 
                    need any help, feel free to contact us.
                    </h6>
                  </Col>
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                </Row>
                <Row >
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                  <Col className = "mb-5 pb-5" xs="12" sm="12" lg="8">
                    <Row>
                      <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                      </Col>
                    </Row>
                  </Col>  
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                </Row>
  
            </Container>
        </div>
        </React.Fragment>
      </div>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/views/Pages/About/About.js